export default __webpack_public_path__ + "static/media/katzdelicatessen.16e6d9f1.jpeg";